import { PaymentMethod, EBEPaymentMethodsName, CheckoutConfigurations } from '../contracts';

const EXPRESS_CHECKOUT_APMS = [
  EBEPaymentMethodsName.apple,
  EBEPaymentMethodsName.google,
  EBEPaymentMethodsName.paypal,
];

const EXCLUDED_AMPS = ['blik', 'link'];

export function getFirstPriorityPaymentMethod(
  paymentMethods: PaymentMethod[],
  checkoutConfigurations: CheckoutConfigurations
) {
  const expressCheckoutApms = [...EXPRESS_CHECKOUT_APMS];
  if (checkoutConfigurations?.shouldShowPayPalAsApm) {
    expressCheckoutApms.splice(expressCheckoutApms.indexOf(EBEPaymentMethodsName.paypal), 1);
  }

  if (checkoutConfigurations?.shouldShowGooglePayAsApm) {
    expressCheckoutApms.splice(expressCheckoutApms.indexOf(EBEPaymentMethodsName.google), 1);
  }

  const filteredApms = paymentMethods?.filter(
    (pm) =>
      !expressCheckoutApms.includes(pm.paymentMethodName as EBEPaymentMethodsName) &&
      !EXCLUDED_AMPS.includes(pm.paymentMethodName)
  );
  return filteredApms?.[0];
}
